/*
 * The category row's trailing affordance.
 *
 * The row scrolls with a finger or a trackpad without any of this. What it
 * cannot do on its own is say that it scrolls: a row of links that ends flush
 * at the viewport edge looks like a row that has ended. So the button appears
 * only when there is something past the edge, and goes away at the end.
 *
 * Nothing here is required to reach any link. Every one of them is also in the
 * drawer nav, and the row is reachable by scroll, keyboard and screen reader
 * whether this file loads or not.
 */
(function () {
  'use strict';

  function init(strip) {
    var row = strip.querySelector('[data-aznav-row]');
    var more = strip.querySelector('[data-aznav-more]');
    if (!row || !more) return;

    function sync() {
      // A one-pixel slack, because a fractional scrollWidth on a zoomed page
      // leaves the button on forever at the far end.
      var left = row.scrollWidth - row.clientWidth - row.scrollLeft;
      more.hidden = left <= 1;
    }

    more.addEventListener('click', function () {
      row.scrollBy({ left: Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
    });

    row.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    // Webfonts land after first paint and change every label's width, so the
    // first measurement is taken again once they have.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
    sync();
  }

  function start() {
    var strips = document.querySelectorAll('[data-aznav]');
    for (var i = 0; i < strips.length; i++) init(strips[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
